module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_actions_related_icon", [["i",{"class":"action-icon inf-icon_linked_23"}]]);
fox.registerTemplate("content_report_icon", [["a",{"class":"content-report-link","data-subject":"message"},[["i",{"class":"action-icon inf-icon_flag_23"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/contentActionsIcons.tpl
// module id = 64
// module chunks = 4